import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle
} from '@mui/material';
import type { DriveResource } from '../types';

interface DeleteResourceDialogProps {
  open: boolean;
  resource?: DriveResource | null;
  deleting: boolean;
  onClose: () => void;
  onConfirm: () => Promise<void>;
}

export const DeleteResourceDialog: React.FC<DeleteResourceDialogProps> = ({
  open,
  resource,
  deleting,
  onClose,
  onConfirm
}) => (
  <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
    <DialogTitle>Delete resource</DialogTitle>
    <DialogContent>
      <DialogContentText>
        Are you sure you want to remove <strong>{resource?.title}</strong>? This action cannot be undone and will
        delete the underlying file from Firebase Storage if applicable.
      </DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose} disabled={deleting}>
        Cancel
      </Button>
      <Button onClick={onConfirm} color="error" variant="contained" disabled={deleting}>
        Delete
      </Button>
    </DialogActions>
  </Dialog>
);

export default DeleteResourceDialog;
